import { useState, useEffect } from 'react'
export function useCountdown(
  initialHours = 23,
  initialMinutes = 59,
  initialSeconds = 59,
) {
  const [timeLeft, setTimeLeft] = useState(
    initialHours * 3600 + initialMinutes * 60 + initialSeconds,
  )
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) {
          return initialHours * 3600 + initialMinutes * 60 + initialSeconds
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [initialHours, initialMinutes, initialSeconds])
  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
